export default class Locale_BlockingDialog { 
	Refresh: string = "Refresh";
}